import { useEffect } from 'react'
import ToastProvider from './FitnessTracker/Toasts/Provider/ToastProvider'
import FitnessTrackerProvider, {
  canUseFitnessTracker,
} from './FitnessTracker/Provider/FitnessTrackerProvider'
import { Layout, Sidebar } from 'react-admin'
import AppBar from './AppBar'
import CustomMenu from './Menu'

const AppSidebar = (props) => {
  return <Sidebar transitionDuration={100} {...props} />
}

const MyLayout = (props) => {
  useEffect(() => {
    const authPassed = localStorage.getItem('auth_passed')

    // NOTE - Hack to fix issue with auth token not existing as 1st page load
    // redirects to dashboard due to issues with `hydraDataProvider` & `convertHydraDataToReactAdminData`
    // possible related issue - https://github.com/marmelab/react-admin/issues/5229
    if (!authPassed) {
      localStorage.setItem('auth_passed', 'true')
      window.location.href = '/#/'
    }
  }, [])

  return (
    <ToastProvider>
      <FitnessTrackerProvider>
        <Layout
          {...props}
          appBar={AppBar}
          menu={CustomMenu}
          sidebar={AppSidebar}
        />
      </FitnessTrackerProvider>
    </ToastProvider>
  )
}

export default MyLayout
